import React from "react";
import { ComingSoonPage } from "@/pages/ComingSoonPage";
import { UserCheck } from "lucide-react";

export default function CustomersPage() {
  return (
    <ComingSoonPage
      title="Customers"
      description="View and manage your customer database, history, and preferences."
      icon={UserCheck}
      accent="#FFED00"
    />
  );
}
